import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownItem from 'react-bootstrap/DropdownItem'
import { useTranslation } from 'react-i18next'
import LocalisationHelper from '../LocalisationHelper'
import RtLanguageDropdownToggle from './RtLanguageDropdownToggle'
import './RtLanguageDropdown.css'

const LANGUAGES = {
  fr: 'Français',
  en: 'English',
}

const RtLanguageDropdown = (props) => {
  const { i18n } = useTranslation()

  const [language, setLanguage] = React.useState(LocalisationHelper.getLanguageCode(i18n.language))

  React.useEffect(() => {
    i18n.changeLanguage(language)
  }, [language, i18n])

  return (
    <div className="rt-language-dropdown">
      <Dropdown align={props.align} onSelect={setLanguage}>
        <Dropdown.Toggle as={RtLanguageDropdownToggle}>
          <div className="rt-language-dropdown-toggle-label">
            <span>{language.toUpperCase()}</span>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu renderOnMount={true}>
          {_.map(LANGUAGES, (name, code) => {
            return (
              <DropdownItem
                key={code}
                className={`rt-language-dropdown-item ${code === language ? 'selected' : ''}`}
                eventKey={code}
              >
                {name} [{code.toUpperCase()}]
              </DropdownItem>
            )
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

RtLanguageDropdown.propTypes = {
  align: PropTypes.string,
}

export default RtLanguageDropdown
